import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

const DigitalMarketing: React.FC = () => {
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Career details" pagesub=" Digital Marketing Executive" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Manager Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            Digital Marketing Executive – (Full-time)
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> Marketing & Growth</li>
                                            <li><span>No. of Openings :</span> (3)</li>
                                            <li><span>Job Type :</span> Full-Time</li>
                                            <li><span>Location :</span> Software Technology Park Chattogram, Level 6, Agrabad Circle, Chittagong, Bangladesh</li>
                                            <li><span>Working days : </span>6 days.</li>
                                            <li><span>Salary Range : </span>Negotiable.</li>
                                            <li><span>Experience Required :</span> 0–4 Year (Fresh Graduates Encouraged)</li>
                                        </ul>

                                        <p className="mb-30">
                                          We’re looking for a results-driven Digital Marketing Executive to join our growth and marketing team. You will be responsible for planning, executing, and optimizing digital marketing campaigns across various channels to increase brand visibility, generate leads, and support business growth. You should be analytical, creative, and comfortable managing multiple projects simultaneously.
                                        </p>

                                        <p>
                                           A strong understanding of digital trends, performance tracking, and audience engagement should come naturally to you. You will collaborate closely with designers, content creators, and product teams to deliver impactful marketing strategies.
                                        </p>
                                    </div>

                                    {/* What you'll do */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">What you'll get to do...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Plan and execute digital marketing campaigns across social media, search, and email.</li>
                                            <li>Manage company pages on Facebook, Instagram, LinkedIn, and other platforms.</li>
                                            <li>Drive SEO/SEM efforts to improve search rankings and website traffic.</li>
                                            <li>Develop and optimize paid ads (Facebook Ads, Google Ads, LinkedIn Ads).</li>
                                            <li>Track campaign performance and generate weekly/monthly reports.</li>
                                            <li>Collaborate with content and design teams to create marketing assets.</li>
                                            <li>Monitor trends, competitors, and market insights to refine strategies.</li>
                                            <li>Manage email marketing campaigns and automate workflows.</li>
                                            <li>Engage with audiences through comments, messages, and community management.</li>
                                            <li>Contribute to branding, product launches, and promotional activities.</li>
                                        </ul>
                                    </div>

                                    {/* Experience section */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Your experience should include...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Strong understanding of social media management and paid ads.</li>
                                            <li>Hands-on experience with Facebook Business Manager and Google Ads.</li>
                                            <li>Good understanding of SEO, keyword research, and on-page/off-page strategies.</li>
                                            <li>Familiarity with analytics tools (Google Analytics, Search Console, Meta Ads Manager).</li>
                                            <li>Ability to create marketing reports and performance dashboards.</li>
                                            <li>Basic knowledge of content planning and creative direction.</li>
                                            <li>Strong communication, coordination, and time-management skills.</li>
                                            <li>Ability to analyze data and make data-driven decisions.</li>
                                            <li>Creativity, attention to detail, and willingness to experiment.</li>
                                          
                                        </ul>
                                    </div>

                                    {/* You might have */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">You might also have...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Experience with Canva, Adobe Photoshop, or Illustrator.</li>
                                            <li>Knowledge of marketing automation tools (Mailchimp, HubSpot).</li>
                                            <li>Understanding of conversion optimization and landing page strategies.</li>
                                            <li>Experience in e-commerce marketing or B2B lead generation.</li>
                                            <li>Familiarity with influencer marketing and partnership outreach.</li>
                                            <li>Knowledge of social media trends, reels, and short-form content strategies.</li>
                                            <li>A passion for marketing, branding, and digital innovation.</li>
                                        </ul>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Great benefits...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Competitive monthly salary with performance reviews.</li>
                                            <li>Opportunity to work on high-scale, real-world applications.</li>
                                            <li>Friendly and collaborative work environment.</li>
                                            <li>Access to learning materials and training sessions.</li>
                                            <li>Flexible working hours.</li>
                                        </ul>
                                    </div>
                                    
                                    {/* ApplyForm */}
                                    <ApplyForm />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default DigitalMarketing;
